import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ColorInputComponent} from './color-input/color-input.component';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';
import {ColorCircleModule} from '../../color-circle/color-circle.module';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faChevronDown, faCog} from '@fortawesome/pro-solid-svg-icons';
import {PresetExtractNamePipe} from './preset-extract-name.pipe';
import {TranslocoModule} from '@ngneat/transloco';
import {ColorDropdownInputComponent} from './color-dropdown-input/color-dropdown-input.component';
import {SelectModule} from '@shared/controls/select/select.module';
import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {RouterModule} from '@angular/router';
import {ColorPanelComponent} from './color-panel/color-panel.component';
import {HueModule, SaturationModule} from 'ngx-color';

@NgModule({
  declarations: [
    ColorInputComponent,
    PresetExtractNamePipe,
    ColorDropdownInputComponent,
    ColorPanelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    ColorCircleModule,
    FontAwesomeModule,
    TranslocoModule,
    SelectModule,
    RouterModule,
    SaturationModule,
    HueModule
  ],
  exports: [
    ColorInputComponent,
    ColorDropdownInputComponent,
    ColorPanelComponent
  ],
  providers: [PresetExtractNamePipe]
})
export class ColorInputModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faChevronDown, faPlus, faCog);
  }
}
